import React, { useState, useCallback } from "react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { ChevronDownIcon } from "lucide-react";
import DailyTokenUsageTable from "./UserManagementComponents/DailyTokenUsageTable";
import UsersList from "./UserManagementComponents/UsersList";
import CreateUser from "./UserManagementComponents/CreateUser";
import UpdateUser from "./UserManagementComponents/UpdateUser";
import MonthlyTokenUsageTable from "./UserManagementComponents/MonthlyTokenUsageTable";
import BedrockCostTable from "./UserManagementComponents/BedrockCostTable";
import BedrockCostMonthlyTable from "./UserManagementComponents/BedrockCostMonthlyTable";
import ArchiveUser from "./UserManagementComponents/ArchiveUser";
import UnverifiedUsers from "./UserManagementComponents/UnverifiedUsers";
import VAUsageDashboard from "./VAUsageDashboard";

const UserManagement: React.FC = () => {
  const [refreshUsers, setRefreshUsers] = useState(0);

  const handleUserChange = useCallback(() => {
    setRefreshUsers((prev) => prev + 1);
  }, []);

  return (
    <div className="mx-auto w-full max-w-screen-lg divide-y divide-gray-200 
      rounded-xl bg-white p-2">
      <DailyTokenUsageTable />
      <MonthlyTokenUsageTable />
      <BedrockCostTable />
      <BedrockCostMonthlyTable />
      <Disclosure as="div" className="py-2">
        <DisclosureButton className="group flex w-full items-center justify-between">
          <span className="text-sm font-medium text-gray-900 group-hover:text-gray-700">
            Virtual Assistant Usage
          </span>
          <ChevronDownIcon className="h-5 w-5 text-gray-400 group-hover:text-gray-300 group-open:rotate-180" />
        </DisclosureButton>
        <DisclosurePanel className="mt-4 text-sm text-gray-600">
          <VAUsageDashboard />
        </DisclosurePanel>
      </Disclosure>
      <UsersList key={refreshUsers} />
      <CreateUser onUserChange={handleUserChange} />
      <UpdateUser onUserChange={handleUserChange} />
      <ArchiveUser onUserChange={handleUserChange} />
      <UnverifiedUsers onUserChange={handleUserChange} />
    </div>
  );
};

export default UserManagement;